import { useCallback, useEffect, useState } from "react";
import useRootTranslation from "../../../hooks/use-root-translation";
import { ContentContainer, ContinueButton, Description, EmailConfirmationLayoutContainer, EmailConfirmationLayoutContent, TalentLogo, Title } from "./email-confirmation-page.styled";


const WAITING_TIME = 60;

const EmailConfirmationPage: React.FC = () => {
  const { root } = useRootTranslation("email-confirmation", "private-home-page");

  const [seconds, setSeconds] = useState<number>(WAITING_TIME);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  }, [seconds, setSeconds])

  const handleClick = useCallback(() => {
    setSeconds(WAITING_TIME);
  }, [setSeconds]);
  
  return (
    <EmailConfirmationLayoutContainer>
      <EmailConfirmationLayoutContent>
        <TalentLogo src="https://talentdio.s3.sa-east-1.amazonaws.com/assets/img/talent-match-onboarding.svg"/>
        <ContentContainer>
          <Title>{root('title')}</Title>
          <Description dangerouslySetInnerHTML={{__html: root('desc_1', { email: '' })}}/>
          <div id='spacer' style={{height: '1rem'}}/>
          <Description dangerouslySetInnerHTML={{__html: root('desc_2', { sec: seconds })}}/>
          <ContinueButton
            disabled={seconds > 0}
            onClick={handleClick}
          >
            {root('button')}
          </ContinueButton>
        </ContentContainer>
      </EmailConfirmationLayoutContent>
    </EmailConfirmationLayoutContainer>
  );
}

export default EmailConfirmationPage;
